import styled from 'styled-components';

export const SwitchGroupContainer = styled.div`
    display: grid;
    grid-template-columns: auto 1fr;
    align-items: start;
    gap: 4px 0;
    width: auto;
`;

export const ParentContainer = styled.div`
    display: inline-flex;
    flex-direction: row;
`;

export const CaptionContainer = styled.div`
    display: flex;
    grid-column: 2;
`;
